var map = {
	"./footer-atis.vue": [
		"8a6f",
		"chunk-2d0e88cf"
	],
	"./footer-bendis.vue": [
		"d54e",
		"chunk-2d21e3b8"
	],
	"./header-atis.vue": [
		"a446",
		"chunk-2d2082ab"
	],
	"./header-bendis.vue": [
		"fb90",
		"chunk-2d2375c9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ca65";
module.exports = webpackAsyncContext;